// extracted by mini-css-extract-plugin
export var hideEditor = "_m7-2";
export var infoIcon = "_m7-3";
export var label = "_m7-1";
export var labelContainer = "_m7-0";
export var readonlyText = "_m7-4";